import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-speciality-hospital',
  templateUrl: './speciality-hospital.component.html',
  styleUrls: ['./speciality-hospital.component.scss']
})
export class SpecialityHospitalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
